import { Input, Label } from 'reactstrap';
import { UserFormGroup } from '../../../../../types/Applications';
import { values } from 'video.js/dist/types/utils/obj';

const CommonUserFormGroup: React.FC<UserFormGroup> = ({
  type,
  title,
  placeholder,
  row,
  isDisabled = false,
  onChange,
  value,
  required = false,
}) => {
  return (
    <div className="mb-3">
      <Label>{title}</Label>
      <Input
        type={type}
        placeholder={placeholder}
        // defaultValue={defaultValue}
        onChange={(e) => {
          if (onChange) onChange(e);
        }}
        rows={row}
        disabled={isDisabled}
        value={value}
        required={required}
      />
    </div>
  );
};

export default CommonUserFormGroup;
